__turbopack_context__.v({
  "btn": "button-module__h0EWEW__btn",
  "input": "button-module__h0EWEW__input",
  "input__blur": "button-module__h0EWEW__input__blur",
  "input__btn": "button-module__h0EWEW__input__btn",
});
